import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.40541 0.198198L0.306306 4.79279C0.108108 4.93694 0 5.17117 0 5.42342V12.5766C0 12.7928 0.0900901 13.009 0.27027 13.1712L5.36937 17.7658C5.51351 17.9099 5.71171 18 5.92793 18H12.0541C12.2523 18 12.4505 17.9279 12.5946 17.7838L17.6937 13.2072C17.8739 13.0631 18 12.8288 18 12.5766V5.42342C18 5.18919 17.9099 4.97297 17.7297 4.82883L12.6306 0.234234C12.4865 0.0900901 12.2883 0 12.0541 0H5.92793C5.74775 0 5.54955 0.0720721 5.40541 0.198198ZM8.1982 9.18919L7.8018 5.6036C7.72973 4.97297 8.37838 4.3964 8.99099 4.3964C9.6036 4.3964 10.2703 4.97297 10.1982 5.6036L9.8018 9.18919C9.74775 9.63964 9.44144 10 8.99099 10C8.55856 10 8.25225 9.63964 8.1982 9.18919ZM8.99099 11.1892C9.65766 11.1892 10.1982 11.7297 10.1982 12.3964C10.1982 13.0631 9.65766 13.6036 8.99099 13.6036C8.34234 13.6036 7.8018 13.0631 7.8018 12.3964C7.8018 11.7297 8.34234 11.1892 8.99099 11.1892Z",
		fill: "#DE6716"
	})
});
export default SvgWarning;
